import { businessPlanAxios } from 'services/controllers/businessPlan';

import * as t from './types';

export const CashFlowApi = {
  getCashReceivedFromCustomerCalculation: async (params: t.IGetCashFromCustomerCalculationsParams) => {
    const { businessPlanId, unit, cashReceivingData } = params;
    const { data } = await businessPlanAxios.put<t.IGetCashFromCustomerResponse>(
      `/${businessPlanId}/cashflow/cashreceived/${unit}`,
      cashReceivingData
    );
    return data;
  },
  
  getCashToSupplierCalculation: async (params: t.IGetCashToSupplierCalculationParams) => {
    const { businessPlanId, unit, cashToSuppliersParams } = params;
    const { data } = await businessPlanAxios.put<t.IGetCashToSupplierResponse>(
      `/${businessPlanId}/cashflow/cashtosupplier/${unit}`,
      cashToSuppliersParams
    );
    return data;
  },

  getLiabilitiesCalculation: async (params: t.IGetLiabilitiesCalculationParams) => {
    const { businessPlanId, unit, liabilitiesParams } = params;
    const { data } = await businessPlanAxios.put<t.IGetLiabilitiesCalculationResponse>(
      `/${businessPlanId}/cashflow/liabilities/${unit}`,
      liabilitiesParams
    );
    return data;
  },
};
